import React, { useEffect } from "react";
import Posts from "../components/Posts";

const Home = () => {
  return (
    <div className="flex-1 min-h-screen">
      <Posts />
    </div>
  );
};

export default Home;
